<template>
  <div id="navbar">
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand>
        <img src="../assets/Fist-White.svg" class="d-inline-block align-top" width="30" />
        Advanced CDN Management
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto" right>
          <b-nav-text v-if="$auth.loading" class="mr-2">Getting auth status...</b-nav-text>
          <b-nav-item v-if="!$auth.loading && !$auth.isAuthenticated" class="mr-2" @click="login">
            Login
          </b-nav-item>
          <b-nav-item v-if="!$auth.loading && $auth.isAuthenticated" class="mr-2" @click="logout">
            Logout
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {};
  },
  methods: {
    login() {
      this.$auth.loginWithRedirect();
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
  },
};
</script>
